import React, { useState, useEffect } from "react";
import Select from "react-select";
import BookingServices from "services/BookingServices";

const IndicatorSeparator = () => null;

const SelectExecutives = ({
  handleReferenceNoChange,
  name,
  client_id,
  employee_name,
  label,
}) => {
  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  useEffect(() => {
    const fetchExecutives = async () => {
      try {
        const response = await BookingServices.getAllExecutive(client_id);
        const data = Array.isArray(response.data)
          ? response.data.map((item) => ({
              value: item.id_employee,
              label: item.employee_name.trim(),
            }))
          : [];
        setOptions(data);

        const selected = employee_name
          ? data.find((item) => item.label === employee_name.trim())
          : null;
        setSelectedOption(selected || null);
        handleReferenceNoChange(selected?.value);
      } catch (error) {
        console.error("Error fetching executives:", error);
      }
    };

    if (client_id) {
      fetchExecutives();
    }
    // eslint-disable-next-line
  }, [client_id, employee_name]);

  const handleChange = (selected) => {
    setSelectedOption(selected);
    handleReferenceNoChange(selected?.value || null);
  };

  return (
    <Select
      name={name}
      styles={{
        control: (base) => ({
          ...base,
          border: "1px solid #ccc",
        }),
      }}
      options={options}
      onChange={handleChange}
      value={selectedOption}
      placeholder={`Select ${label}`}
      components={{
        IndicatorSeparator,
      }}
    />
  );
};

export default SelectExecutives;
